var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavLinks',{staticClass:"footer-nav-links"})
}
var staticRenderFns = []

export { render, staticRenderFns }